export default {
  dictionaryManager: {
    labelvalue: {
      getDictionary: '/api/dictionaryManager/labelvalue/getDictionary',
      getDictionaryItems: '/api/dictionaryManager/labelvalue/getDictionaryItems',
      getDicByCategory: '/api/dictionaryManager/labelvalue/getDicByCategory',
      delDic: '/api/dictionaryManager/labelvalue/delDictionary',
      delCategory: '/api/dictionaryManager/labelvalue/delCategory',
      initCategoryList: '/api/dictionaryManager/labelvalue/initCategoryList',
      saveDic: '/api/dictionaryManager/labelvalue/saveDictionary',
      updateDic: '/api/dictionaryManager/labelvalue/updateDictionary',
      saveCategory: '/api/dictionaryManager/labelvalue/saveCategory',
      updateCategory: '/api/dictionaryManager/labelvalue/updateCategory'
    },
    industry: {
      getTree: 'api/dictionaryManager/industry/tree',
      saveDic: '/api/dictionaryManager/industry/saveIndustry',
      updateDic: '/api/dictionaryManager/industry/updateIndustry',
      delDic: '/api/dictionaryManager/industry/delIndustry',
      getByPCode: '/api/dictionaryManager/industry/getByPCode',
      getByCode: '/api/dictionaryManager/industry/getByCode'
    },
    region: {
      getTree: 'api/dictionaryManager/region/tree',
      getLvTree: '/api/dictionaryManager/region/lvTree',
      saveDic: '/api/dictionaryManager/region/saveRegion',
      updateDic: '/api/dictionaryManager/region/updateRegion',
      delDic: '/api/dictionaryManager/region/delRegion',
      getSubArea: '/api/dictionaryManager/region/getSubArea',
      subTreeByFullCode: '/api/dictionaryManager/region/subTreeByFullCode'
    },
    specialty: {
      getFullTree: 'api/dictionaryManager/dicSpecialty/getFullTree',
      saveSpecialty: '/api/dictionaryManager/dicSpecialty/saveSpecialty',
      updateSpecialty: '/api/dictionaryManager/dicSpecialty/updateSpecialty',
      delSpecialty: '/api/dictionaryManager/dicSpecialty/delSpecialty',
      dynamicTree: '/api/dictionaryManager/dicSpecialty/dynamicTree'
    },
  }
}
